export default __webpack_public_path__ + "static/media/contrast_colors_distance.cfd2cd03.jpg";